import categoryService from "app/common/services/categoryService";
import { booleanSearchToObject } from "app/pages/website-analysis/traffic-sources/search/booleanSearchUtility";
import DurationService from "app/services/DurationService";

import { extractPrimaryCategoryFromParams } from "../routes/routeUtils";

export const getInitialFilters = (params, sort) => {
    const {
        category,
        webSource,
        duration,
        country,
        includeSubdomains = true,
        includeBranded: includeBrandedString,
        includeNoneBranded: includeNoneBrandedString,
        IncludeNewKeywords: IncludeNewKeywordsString,
        IncludeTrendingKeywords: IncludeTrendingKeywordsString,
        BooleanSearchTerms: booleanSearchTermsWithPrefix,
    } = params;
    const primaryCategory = extractPrimaryCategoryFromParams(category);
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(primaryCategory);
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const includeBranded = includeBrandedString === true.toString();
    const includeNoneBranded = includeNoneBrandedString === true.toString();
    const IncludeNewKeywords = IncludeNewKeywordsString === true.toString();
    const IncludeTrendingKeywords = IncludeTrendingKeywordsString === true.toString();
    return {
        keys: categoryObject.forApi,
        duration,
        from,
        to,
        webSource,
        isWindow,
        includeSubdomains,
        country,
        category: categoryObject.forDisplayApi,
        orderBy: `${sort.field} ${sort.sortDirection}`,
        ...((!includeBranded || !includeNoneBranded) && {
            IncludeBranded: includeBranded,
            IncludeNoneBranded: includeNoneBranded,
        }),
        IncludeNewKeywords,
        IncludeTrendingKeywords,
        ...(booleanSearchTermsWithPrefix && booleanSearchToObject(decodeURIComponent(booleanSearchTermsWithPrefix))),
    };
};
